export default {
  meta: {
    label: 'English'
  },
  data: {
    'en-CA': {
      97:  [['🧮','abacus'], ['✈','airplane'], ['🚑','ambulance'], ['🐜','ant'], ['🍎','apple'], ['👽','alien'], ['⚓','anchor'], ['🥑','avacado']],
      98:  [['👶','baby'], ['🍌','banana'], ['🍼','baby bottle'] , ['🦇','bat'], ['🐝','honey bee'], ['🥓','bacon'], ['🦡','badger'], ['🥯','bagel'], ['🍞','bread'], ['🎈','balloon'], ['⚾','baseball'], ['🏀','basketball'], ['🛁','bathtub'], ['🐻','bear'], ['🌯', 'burrito']],
      99:  [['🐄','cow'], ['🐱','cat'], ['🐈','cat'], ['🤠','cowboy'], ['🛶','canoe'], ['🍒', 'cherries'], ['🥕', 'carrot'], ['🌽', 'corn'], ['🥐', 'croissant'], ['🧀', 'cheese'], ['🌵', 'Cactus']],
      100: [['🐶','dog'], ['💃','dancer'], ['🦌','deer'], ['🥟', 'dumpling'], ['🐉', 'dragon']],
      101: [['🥚','egg'], ['👁️','eye'], ['👀', 'eyes'], ['👂', 'Ear'], ['🦅','eagle'], ['✉', 'envelope'], ['📧', 'e-mail'], ['💶', 'euro']],
      102: [['🐸','frog'], ['🍟','fries'], ['👣','feet'], ['🔥', 'fire'], ['🎡', 'ferris wheel']],
      103: [['🍇','grapes'], ['👻','ghost'], ['🦍','gorilla'], ['🎸', 'guitar']],
      104: [['🥅','hockey net'], ['🏒','hockey stick'], ['🐹','hamster'], ['🌺','hibiscus'], ['🍯', 'Honey'], ['🍔', 'hamburger'], ['🐎', 'horse'], ],
      105: [['🍦','ice cream'], ['🏒', 'ice hockey']],
      106: [['🤹🏼‍','juggler'], ['👖','jeans'], ['🕹️','joystick'], ['🇯🇲', 'Jamaica'], ['🇯🇵 ', 'Japan']],
      107: [['🔪','knife'], ['🔑','key'], ['🥝', 'Kiwi']],
      108: [['🦁','lion'], ['🦎','lizard'], ['🐆','leopard'], ['💡', 'Lamp'], ['🍋', 'lemon']],
      109: [['🌙','moon'], ['📫','mailbox'], ['🍈','melon'], ['👄','mouth'], ['🥭', 'Mango'], ['⛰', 'mountain'], ['🚇', 'metro'], ['🏍', 'motorcycle']],
      110: [['👃','nose'], ['🎶','notes'], ['📓', 'notebook'], ['📰', 'newspaper']],
      111: [['🐙','octopus'], ['👌','O.K.'], ['🍊', 'Orange'], ['🐂', 'Ox'], ['🦉', 'owl']],
      112: [['🥞','pancakes'], ['🍐','papaya'], ['🥘','pot'], ['🦚', 'Peacock'], ['🍑', 'Peach'], ['🍍', 'Pineapple'], ['🍐', 'Pear'], ['🐼', 'panda'], ['🍕', 'Pizza']],
      113: [['👸🏻','queen'], ['🇶🇦','Qatar'], ['❓','question mark']],
      114: [['🐇','rabbit'], ['🤖','robot'], ['♻️','recycling'], ['🚀','rocket'], ['🌈', 'Rainbow'], ['🌧', 'Rain'], ['🦏', 'rhinoceros'], ['🌹', 'rose']],
      115: [['🐍','snake'], ['🤳','selfie'], ['🥗','salad'], ['⭐️','star'], ['⛄️', 'Snowman'], ['🍤', 'Shrimp'], ['🦑', 'squid'], ['🍓', 'strawberry']],
      116: [['🦃','turkey'], ['🐯','tiger'], ['🐅','tiger'], ['🌮','taco'], ['🍊', 'Tangerine'], ['🌷', 'tulip'], ['🎾', 'tennis']],
      117: [['☂️','umbrella'], ['🆙','up'], ['🦄','unicorn']],
      118: [['🎻','violin'], ['🏐','volleyball'], ['🌋','volcano']],
      119: [['🌊','wave'], ['🍉','watermelon'], ['🚶','walking']],
      120: [['💀','x-ray'],['✖e','xenon']],
      121: [['💴','yen'], ['☯️','yin-yang'], ['🧒','young']],
      122: [['⚡️','zap'], ['🤐','zipper'], ['🦓', 'zebra']]
    }
  }
};
